import { render } from "./table-rekap-evaluasi.vue?vue&type=template&id=d394bd50"
import script from "./table-rekap-evaluasi.vue?vue&type=script&lang=js"
export * from "./table-rekap-evaluasi.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__